import React from 'react';
import * as bookingTypes from 'store/booking/types';
import { MuiFormControl, MuiInputLabel, MuiMenuItem, MuiSelect } from 'theme/material-ui';

import { convertToLowerKabobCase } from 'modules/utils/StringUtils';
import { Color } from 'modules/styles/colors';

interface Props {
  specialties: bookingTypes.Specialty[];
  selectedSpecialty: bookingTypes.Specialty | null;
  handleSpecialtySelect: Function;
}

const SelectSpecialty = ({ specialties, selectedSpecialty, handleSpecialtySelect }: Props) => (
  <MuiFormControl fullWidth variant="outlined">
    <MuiInputLabel id="booking-provider-specialty-select-label">
      Available Specialties
    </MuiInputLabel>
    <MuiSelect
      style={{ backgroundColor: Color.white }}
      labelId="booking-provider-specialty-select-label"
      id="booking-provider-specialty-select"
      data-testid="booking-provider-specialty-select"
      value={selectedSpecialty ?? ''}
      onChange={handleSpecialtySelect}
      label="Available Specialties"
    >
      {specialties.map(specialty => (
        <MuiMenuItem
          key={specialty.id ?? specialty?.nameShort}
          value={specialty}
          data-testid={convertToLowerKabobCase(specialty.nameLong)}
        >
          {specialty?.moreInfo?.title ? specialty?.moreInfo?.title : specialty.nameLong}
        </MuiMenuItem>
      ))}
    </MuiSelect>
  </MuiFormControl>
);

export default SelectSpecialty;
